import UtilityService, { prepAutocompleteData, serialize } from '@/services/UtilityService';
import ApiFactory from '@/factories/ApiFactory';

const getCountries = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`systemadmin/v1/countries`).then(
			({ data }) => {
				resolve(prepAutocompleteData(data.data, 'description', 'id'));
			},
			(error) => reject(error)
		);
	});
};
const getCities = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`systemadmin/v1/cities?${query}`).then(
			({ data }) => {
				resolve(prepAutocompleteData(data.data, 'description', 'id'));
			},
			(error) => reject(error)
		);
	});
};

const getPaymentTypes = (businessId) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`posweb/v1/businesses/${businessId}/payment-types`).then(
			({ data }) => {
				let response = prepAutocompleteData(data.data, 'description', 'id');
				response.forEach((item) => {
					if (item.label) item.label = UtilityService.filters.capitalization(item.label);
				});
				resolve(response);
			},
			(error) => reject(error)
		);
	});
};

const getCityFromName = (city) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`/mobile/v1/cities/${city}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

export default {
	getCountries,
	getCities,
	getPaymentTypes,
	getCityFromName,
};
